/* ============================================================
   Toast.jsx — composant unitaire affiché dans la stack du Provider
   ============================================================
   Sprint 2 P2 — design system global.

   Sécurité : le `message` est UNIQUEMENT rendu en text content via
   {message} JSX. JAMAIS de dangerouslySetInnerHTML — le hook accepte
   du texte arbitraire (incluant des messages d'erreur backend) qui
   pourrait contenir du HTML/JS injecté. React échappe par défaut.

   Test mental anti-XSS :
     toast.success('<img src=x onerror=alert(1)>')
   → doit afficher la string littérale, pas exécuter le script.
   ============================================================ */
import React from 'react';
import styles from './Toast.module.css';

// Mapping variant → icône + classe CSS
const VARIANT_CONFIG = {
  success: { icon: '✓', className: styles.success, ariaLive: 'polite' },
  error:   { icon: '⚠',  className: styles.error,   ariaLive: 'assertive' },
  warning: { icon: '⚠',  className: styles.warning, ariaLive: 'polite' },
  info:    { icon: 'ℹ',  className: styles.info,    ariaLive: 'polite' },
};

export default function Toast({ variant = 'info', message, onDismiss }) {
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.info;

  return (
    <div
      className={`${styles.toast} ${config.className}`}
      role={variant === 'error' ? 'alert' : 'status'}
      aria-live={config.ariaLive}
    >
      <span className={styles.icon} aria-hidden="true">{config.icon}</span>
      <span className={styles.message}>{message}</span>
      <button
        type="button"
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label="Fermer la notification"
      >
        ×
      </button>
    </div>
  );
}
